import { Tab, Tabs } from '@heroui/react';
import { RiNumber1, RiNumber2, RiNumber3, RiNumber4, RiNumber5 } from 'react-icons/ri';
import { useRecord } from '@/store/record';

export const ChoicesGrid = ({ count = 3 }: { count?: number }) => {
  const choicesGridCols = useRecord.use.choicesGridCols();
  const setChoicesGridCols = useRecord.use.setChoicesGridCols();

  const icons = [RiNumber1, RiNumber2, RiNumber3, RiNumber4, RiNumber5];

  return (
    <Tabs
      selectedKey={choicesGridCols}
      size='sm'
      variant='solid'
      onSelectionChange={(key) => setChoicesGridCols(key?.toString?.() ?? '')}
    >
      {Array.from({ length: count }).map((_, index) => {
        const Icon = icons[index];
        return (
          // biome-ignore lint/suspicious/noArrayIndexKey: <disabled>
          <Tab key={index + 1} title={Icon ? <Icon /> : null} />
        );
      })}
    </Tabs>
  );
};
